function admissionsAjax(){


  // Submit Admission filter
  function handleFormSubmit(e) {
    e.preventDefault();
    //console.log('form submitted');
  
    var errorMessage = document.querySelector('.js-error-info');
    $(errorMessage).empty();
    
    var nameInput = document.getElementById('first-name');
    var name = nameInput.value;

    var monthDropdown = document.getElementById("birth-month-dropdown");
    var month = monthDropdown.options[monthDropdown.selectedIndex].value;
    if (month == -1) {
      month = '';
      monthDropdown.className = 'error';
    }  else {
      monthDropdown.classList.remove('error');
    }
  
    var yearDropdown = document.getElementById("birth-year-dropdown");
    var year = yearDropdown.options[yearDropdown.selectedIndex].value;
    if (year == -1) {
      year = '';
      yearDropdown.className = 'error';
    } else {
      yearDropdown.classList.remove('error');
    }
  
    var locationDropdown = document.getElementById("location-dropdown");
    var location = locationDropdown.options[locationDropdown.selectedIndex].value;
    if (location == -1) {
      location = 'domestic';
    }
  
    var post_id = document.querySelector(".admissions-filter-form").getAttribute('rel');
  
    var html = 'Please select both a month and year of birth';
    errorMessage.insertAdjacentHTML('beforeend', html);
  
  
    loadAdmissionsProcess(month, year, location, name, post_id);
  }
  
  if (document.querySelector('.js-admission-form-submit')) {
    document.querySelector('.js-admission-form-submit').addEventListener('click', handleFormSubmit, false);
  }
  
 
  
  // Trigger AJAX function
  function loadAdmissionsProcess(month, year, location, name, post_id) {
    //console.log('ajax triggered');
    if (month && year && location) {
  
  
      // Clear error message from form
      var errorMessage = document.querySelector('.js-error-info');
      $(errorMessage).empty();
  
  
      $.ajax({
        type: 'POST',
        url: php_vars.ajaxUrl,
        dataType: 'html',
        data: {
          action: 'calculate_admissions_process',
          mode: 'POST',
          month: month,
          year: year,
          location: location,
          name: name,
          post_id: post_id,
        },
        success: function success(html) {
  
          var destination = document.querySelector('.js-admissions-process');
  
          $(destination).empty();
  
          destination.insertAdjacentHTML('beforeend', html);

          admissionsTabs();


        },
        error: function error(_error) {
          console.error(_error);
          console.log('test');
        }
      });
    }
  }



  function admissionsTabs() {
    $('.tabs__controls li').click(function(){
      var tab_id = $(this).attr('data-tab');

      $('.tabs__controls li').removeClass('tab-active');
      $('.tabs__controls li').addClass('tab-inactive');
      $('.tabs__content').hide();
      //$('.tabs__content').removeClass('active');

      $(this).addClass('tab-active');
      //$("#"+tab_id).addClass('active');
      $("#"+tab_id).show();
    });
  
  }
	

}

export { admissionsAjax };
